<template>
    <div style="font-size: 23.4375px;">
        <!--    导航栏-->
<!--        <Anav></Anav>-->
        <van-nav-bar fixed @click-left="onClickLeft" @click-right="onClickRight()"
                     style="background-color: #fff;">
            <template #left>
                <van-icon class="hover-color" style="font-size: 20px" color="#666" name="arrow-left" role="button" aria-label="返回"/>
            </template>
            <template #right>
                <van-icon aria-label="首页" role="button" name="home-o" style="font-size: 20px" color="#666" />
            </template>
        </van-nav-bar>
<!--        分享-->
        <share></share>
        <div class="box">
<!--            文章内容-->
            <div class="article-box">
                <div style="height: 46px"></div>
                <div class="title">理赔流程</div>
<!--                <div class="date">2020-08-13</div>-->
                <div class="content">
                    <p>发生需要理赔的情况，请先拨打95511转9报案，并联系视安小宝，电话13661329617，小宝会协助您完成后续理赔。</p>
<!--                    <p>一般在大家刚买新车的时候就会要求强制购买交强险，所以一旦发生交通事故，当事人都可以报警，让警察认定交通事故责任，双方当事人可以在保险范围内进行索赔，那么，交通事故保险赔付时限是多久呢?下面保险师为您详细介绍。</p>-->
<!--                    <p>什么是保险理赔？</p>-->
<!--                    <p>保险理赔，是指在保险标的发生保险事故而使被保险人财产受到损失或人身生命受到损害时，或保单约定的其它保险事故出现而需要给付保险金时，保险公司根据合同规定，履行赔偿或给付责任的行为，是直接体现保险职能和履行保险责任的工作。交通事故保险理赔应在保险时限内进行赔偿，否则，超过了保险时限，保险公司将不再赔偿。</p>-->
<!--                    <p>交强险理赔期限是多久？</p>-->
<!--                    <p>参考如下《机动车交通事故责任强制保险条例》</p>-->
<!--                    <p>第二十八  被保险机动车发生道路交通事故的，由被保险人向保险公司申请赔偿保险金。保险公司应当自收到赔偿申请之日起1日内，书面告知被保险人需要向保险公司提供的与赔偿有关的证明和资料。</p>-->
<!--                    <p>第二十九  保险公司应当自收到被保险人提供的证明和资料之日起5日内，对是否属于保险责任作出核定，并将结果通知被保险人;对不属于保险责任的，应当书面说明理由;对属于保险责任的，在与被保险人达成赔偿保险金的协议后10日内，赔偿保险金。</p>-->
<!--                    <p>交通事故保险理赔流程主要包括</p>-->
<!--                    <p>(一)、向保险公司报案。通常一起交通事故发生后，车辆方不仅要向当地的交通管理部门报案，同时要在事故发生后的48小时内向保险公司报案。</p>-->
<!--                    <p>(二)、事故现场勘查、检验。保险公司接到出险报案后，应当立即安排公司理赔人员或委托的公共机构、技术鉴定机构、海外代理人到事故现场勘查事故经过，了解涉及的损失情况，查阅和初步收集与事故性质、原因和损失情况等有关的证据和资料，确认事故是否属于保险责任，必要时委托专门的技术鉴定部门或科研机构提供专业技术支持。-->
<!--                    </p>-->
<!--                    <p>(三)、定损估价。保险公司相关人员对交通事故现场进行勘查、检验后，就应该对此次事故造成的损失估价。如果被保险人认为保险公司的定损估价有问题时，被保险人也可以向保险公司提出异议，同时自己委托相关机构对损失作出估价。保险公司与被保险人对损失估计达成一致，就进行下一步流程。</p>-->
<!--                    <p>(四)、提交索赔材料。权利虽然被赋予了，但是如果自己不懂得主张的话，那权利很可能就是白费的。所以，当确定了损失以后，被保险人就可以向保险公司索赔了。通常，被保险人向保险公司索赔的时候，要提交如保险单、索赔申请等与该起事故有关的单证材料，方便保险公司核实。</p>-->
<!--                    <p>(五)、赔款的计算和审核。保险公司审核了被保险人所提交的索赔材料以后，如果真实可靠，保险公司就应该按照保险合同的约定承担保险责任，确定具体的赔偿款数额。</p>-->
<!--                    <p>(六)、领取保险金。保险公司作出了赔偿决定后，就可以通知被保险人在规定的期限内到保险公司领取保险金。</p>-->
<!--                    <p>(七)、协助追偿。在很多情况下，保险公司在赔付了被保险人的损失后，法律还赋予了保险公司向真正的肇事方索赔。此时，被保险人不能认为反正自己已经获得了赔偿，就拒绝帮助甚至阻碍保险公司向真正的肇事方索赔。</p>-->
<!--                    <p>通过以上我们可以知道交通事故发生后，责任认定很重要，在保险理赔的期限内提起保险理赔也很重要，注意不要过了理赔时间就可以了。</p>-->

                
                </div>
            </div>


        </div>
        <div style="height: 60px"></div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Field, Button, Notify, Icon} from 'vant';
    //引入导航组件
    import share from './Acomponent/Atablebar_share';
    Vue.use(Field).use(Button).use(Notify);
    Vue.use(Icon);
    export default {
        components:{
            // Anav,
            share,
        },

        name: "Login",
        data() {
            return {

            }
        },
        props: {
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {
                window.location.href = 'Ahome?type=0'
            }
        }
    }
</script>

<style scoped>
    p{
        margin: 0;
    }
    .box{
        padding-top: 46px;
        background-color: #fff;
    }
    .article-box{
        width: 92vw;
        margin: 0 auto;
    }
    .article-box .title{
        color:#333;
        text-align: center;
        font-size: 28px;
        line-height: 40px;
        font-weight: bold;
        margin-bottom: 1rem;
    }
    .article-box .date{
        color: #b3b3b3;
        font-size: 16px;
        line-height: 48px;
    }
    .article-box .content{
        color: #666;
        font-size: 22px;
        line-height: 40px;
        font-family: normal;
        font-weight: 300;
        min-height: 50vh;
    }
    .article-box .content p{
        padding-bottom: 20px;
        text-indent:44px;
    }

</style>
